module.exports = __webpack_public_path__ + "static/img/4d3007fce0c4021abf691ffc1c6958ac.b42afb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4d3007fce0c4021abf691ffc1c6958ac.png
// module id = 5w54
// module chunks = 3